var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.mounted)?_c(_setup.Editor,{attrs:{"license-key":"gpl","disabled":_vm.disabled,"init":{
            setup: _setup.initEditor,
            licenseKey: 'gpl',
            height: 400,
            convert_urls: false,
            content_style: '.mce-content-body {font-size:14px;font-family:Avenir, Helvetica, sans-serif;}',
            promotion: false,
            plugins: 'code image',
            link_default_target: '_blank',
            link_target_list: [
                { text: 'New window', value: '_blank' }
            ]
        },"toolbar":[_vm.mergeFields.length > 0 ? 'mergeFields' : '', 'bold italic forecolor backcolor undo redo formatselect bullist numlist code']},on:{"input":_setup.change},model:{value:(_setup.localValue),callback:function ($$v) {_setup.localValue=$$v},expression:"localValue"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }